import { render, staticRenderFns } from "./PaxelcoDashboard.vue?vue&type=template&id=ba43d684&"
import script from "./PaxelcoDashboard.vue?vue&type=script&lang=js&"
export * from "./PaxelcoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports